import axios from "axios";

const token = localStorage.getItem("Bearer");

export const axiosInstance = axios.create({
  baseURL: process.env.RETRO_WEB_API_URL,
  timeout: 5000,
  headers: {
    Authorization: `Bearer ${token}`,
  },
});
